import { Product } from '../dto';

export type ProductStockBadgeType = 'rocket' | 'europe' | 'america';

export interface ProductStockBadge {
  type: ProductStockBadgeType;
  label: string;
  value: number;
}

export const getProductStockBadges = (product: Product | null | undefined): ProductStockBadge[] => {
  const badges: ProductStockBadge[] = [];
  const seen = new Set<string>();

  for (const mapperSaleProduct of product?.mapperSaleProducts ?? []) {
    const option = mapperSaleProduct?.productOption;
    if (!option) {
      continue;
    }

    if (option.rocketStock > 0 && !seen.has('rocket')) {
      badges.push({ type: 'rocket', label: 'U-Quick', value: option.rocketStock });
      seen.add('rocket');
    }
    if (option.europeStock > 0 && !seen.has('europe')) {
      badges.push({ type: 'europe', label: 'Direct', value: option.europeStock });
      seen.add('europe');
    }
    if (option.americaStock > 0 && !seen.has('america')) {
      badges.push({ type: 'america', label: 'Direct', value: option.americaStock });
      seen.add('america');
    }
  }

  return badges;
};
